import api from "../../api/client";
import { API_ROUTE } from "../../api/endpoints";
import { toArray } from "./normalizers";

export async function getRegions(enterprise = "ACM") {
  const { data } = await api.get(API_ROUTE.GET_REGIONS(enterprise));
  return toArray(data);
}
